module.exports = __webpack_public_path__ + "img/8.c21f6082.png";